import { Input, CommonInputProps } from 'src/shared/ui/Input'
import { LoopIcon } from 'src/shared/icons'

export const Search = (props: CommonInputProps) => (
  <Input leftAddons={<LoopIcon />} clear labelClearButton="Очистить" {...props} />
)
